import modal from "bootstrap/js/dist/modal";

export default `
<div v-if="isopen" id="ig-popup">	
	<div class="modal-content" style="display:block">
		<div class="modal-body" :style="{top: stop + 'px'}">
		  <div @click.prevent="closePopup" class="close" data-target="#ig-popup"></div>
		  <a class="Introduction d-md-none d-block" :href="item.Url" target="_blank">
			<img class="mug" :src="item.Owner.ProfilePicUrl" />
			<span class="igId">{{item.Owner.UserName}}</span>
			<span class="igIntroduction">{{item.Text}}</span>
		  </a>
		  <div class="modal-left-column">
		    <img class="img-fluid w-100" :src="item.Cover" />
		    <p class="share">
		      <span>Share this</span>
		      <a class="fbShare btn-share-this" data-social="fb" href="#"></a>
		      <a :data-clipboard-text="link" id="copyLink" href="#" class="copyLink btn-share-this" data-social="link"></a>
		    </p>
		  </div>
		  <div class="modal-right-column">
		      <a class="Introduction d-none d-md-block" :href="item.Url" target="_blank">
		        <img class="mug" :src="item.Owner.ProfilePicUrl" />
		        <span class="igId">{{item.Owner.UserName}}</span>
		        <span class="igIntroduction">{{item.Text}}</span>
		      </a>
		      <div class="nanoscroll nano">
			    <ul class="nanoscroll__content">
			        <li v-for="(market, index) in item.MarketColors" :key="market.ID">
			          <a class="ProductLink" :href="market.Url" :title="market.MarketName" target="_blank">
			          	<new-image :url="market.MarketCover" :size="'_w318_h397'" :name="market.MarketName"></new-image>
			            <span>{{market.MarketName}}</span>
			          </a>
			        </li>
			    </ul>
		      </div>
		    <a class="DescriptionLink" title="活動規則" href="#" data-toggle="modal" data-target="#lb-ig-privacy"></a>
		  </div>
		  <a @click.prevent="goPost('pre')" class="photo-arrow photo-left pre" href="#"></a>
		  <a @click.prevent="goPost('next')" class="photo-arrow photo-right nex" href="#"></a>
		</div>
		<a @click.prevent="closePopup" class="BGclose" href="#"></a>
	</div>
</div>
`;
